<template>
    <div class="mt-0">
        <div class="row p-2 mt-3" id="lower-div">
            <div class="card mb-4">
                <div class="dict-table-container p-3">
                    <div class="dict-table-toolbar d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                        <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn action-btn action-btn--success"
                                @click="OpenDialog(0, false, null, 'COMPLAINT')">
                                <i class="bi bi-plus-lg"></i>
                                <span>Təzə yazı</span>
                            </button>
                            <button type="button" class="btn action-btn action-btn--muted" @click="GetComplaints">
                                <i class="bi bi-arrow-clockwise"></i>
                                <span>Yeniləmək</span>
                            </button>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-3" v-loading="loading">
                        <Table @open-dialog="OpenDialog" @get-data="GetComplaints" :refindex="this.complaint.refindex"
                            :constindex="this.complaint.constindex" :data="ComplaintList"></Table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog :close-on-click-modal="false" v-model="this.complaint.dialogVis"
        :title="this.editing ? 'Şablon dəyişilməsi' : 'Yeni şablon'" modal-class="modal-class" :destroy-on-close="true"
        style="margin-top: 15%;" width="35%">
        <complaint-dialog :object="complaint.object" :editing="editing" @close-dialog="this.complaint.dialogVis = false"
            @insert-dialog="Insert"></complaint-dialog>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" v-model="this.det.dialogVis"
        :title="this.editing ? 'Şikəyət dəyişilməsi' : 'Yeni şikəyət'" modal-class="modal-class" :destroy-on-close="true"
        style="margin-top: 15%;" width="35%">
        <complaint-det-dialog :object="det.object" :editing="editing" @close-dialog="this.det.dialogVis = false"
            :id="this.complaint.constindex" @insert-dialog="Insert"></complaint-det-dialog>
    </el-dialog>
</template>
<script>
import Table from "./Components/Tables/Table.vue";
import ComplaintDetDialog from "./Components/Dialogs/ComplaintDetDialog.vue";
import ComplaintDialog from "./Components/Dialogs/ComplaintDialog.vue";


export default {
    components: {
        Table,
        ComplaintDetDialog,
        ComplaintDialog
    },
    data() {
        return {
            loading: null,
            ComplaintList: [],
            complaint: {
                dialogVis: false,
                object: null,
                refindex: 0,
                constindex: 0
            },
            det: {
                dialogVis: false,
                object: null
            },
        }
    },
    methods: {
        GetComplaints() {
            
            //None
        },
        Insert() {
            if (this.type == 'COMPLAINT') {
                this.complaint.dialogVis = false
                this.GetComplaints()
            }
            else {
                this.complaint.refindex = this.complaint.refindex + 1
                this.det.dialogVis = false
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            this.complaint.constindex = index
            if (type == 'COMPLAINT') {
                this.complaint.constindex = index
                this.complaint.dialogVis = true
                this.complaint.object = object
            } else if (type == 'DET') {
                this.det.dialogVis = true
                this.det.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetComplaints()
    }
}
</script>